import { fixUrl, mToKm } from "@/helpers/commonHelper";
import PictureMixin from "@/mixins/PictureMixin.vue";
import ColorsMixin from "@/mixins/ColorsMixin.vue";
import Attach from "@/components/Attach/Attach.vue";
import PoiRegionSubjects from "@/components/PoiRegionSubjects/PoiRegionSubjects.vue";
import PoiDetailStatus from "@/components/PoiDetailStatus/PoiDetailStatus.vue";
import PoiOpenClosed from "@/components/PoiOpenClosed/PoiOpenClosed.vue";
import ExcursionTicker from "@/components/ExcursionTicker/ExcursionTicker.vue";
import TourBestSeason from "@/components/TourBestSeason/TourBestSeason.vue";
import TourDescriptionTabs from "@/components/TourDescriptionTabs/TourDescriptionTabs.vue";
import TourDetails from "@/components/TourDetails/TourDetails.vue";
import TourDetailStatus from "@/components/TourDetailStatus/TourDetailStatus.vue";
import TourDetailTip from "@/components/TourDetailTip/TourDetailTip.vue";
import Features from "@/components/Features/Features.vue";
import SocialIcons from "@/components/SocialIcons/SocialIcons.vue";
import RelatedPoisTeaser from "@/components/RelatedPoisTeaser/RelatedPoisTeaser.vue";
import {
  checkStep,
  getColorForParkingLot,
  navigate,
  onFavoritesClick,
  downloadGpx
} from "@/helpers/detailViewHelper.js";
import "./TourDetailView.scss";

export default {
  props: [
    "poi",
    "isCompactView",
    "shortDescription",
    "featureList",
    "highlightFeatures",
    "currentMessage",
    "currentSeason",
    "description",
    "listUri",
    "mainPois",
    "settings",
    "openPanel",
    "connectedParkingLots",
    "myURL",
    "isFavorite",
    "socialMediaKeys",
    "showNotepad",
    "isOutdoorActiveTour",
    "outdoorActiveTourId"
  ],
  components: {
    Attach,
    PoiRegionSubjects,
    PoiDetailStatus,
    PoiOpenClosed,
    ExcursionTicker,
    TourBestSeason,
    TourDescriptionTabs,
    TourDetails,
    TourDetailStatus,
    TourDetailTip,
    Features,
    SocialIcons,
    RelatedPoisTeaser
  },
  mounted() {
    if (this.isOutdoorActiveTour && this.outdoorActiveTourId) {
      this.addRobotsMetaTag();
      this.addOutdoorActiveTourDataDownloadButton();
    }
  },
  mixins: [ColorsMixin, PictureMixin],
  methods: {
    onFavoritesClick,
    fixUrl,
    mToKm,
    getColorForParkingLot,
    navigate,
    downloadGpx,
    checkStep(step, poi) {
      return checkStep(step, poi, this.categoryGroups, this.categoryTypes);
    },
    linkToParkingLot(slug) {
      if (slug) window.location.assign(slug);
    },
    addRobotsMetaTag() {
      if (!this.poi.importMetaData?.robots) {
        return;
      }
      const meta = document.createElement("meta");
      meta.setAttribute("robots", this.poi.importMetaData.robots);
      document.head.appendChild(meta);
    },
    addOutdooractivePdfDialogCSS() {
      const styleTagId = "eopois-widget-oa-pdf-dialog-styles";
      if (document.querySelector(`style#${styleTagId}`)) {
        return;
      }
      const css = `.oax.oax_modal_wrap{
  --onSurfaceContainerVariant_darkMode: #C1C4B8;
  --inversePrimary_darkMode: #6A7314;
  --surfaceContainerHighest: #DEDEDE;
  --inverseOnSurface: #FFFFFF;
  --onPrimaryContainer: #272727;
  --onPrimary_darkMode: #272727;
  --outline_darkMode: #7B7B7B;
  --primaryContainer: #A5B339;
  --tertiaryContainer: #DBDDD3;
  --tertiaryFixedDim: #D0D1C7;
  --onError_darkMode: #272727;
  --secondaryContainer: #E0E6B3;
  --secondaryContainer_darkMode: #484D28;
  --onErrorContainer: #272727;
  --onSurfaceContainer_darkMode: #FFFFFF;
  --surfaceBright: #FFFFFF;
  --surfaceContainerHigh_darkMode: #272727;
  --tertiaryContainer_darkMode: #464641;
  --onSecondaryFixedVariant: #33342B;
  --primaryContainer_darkMode: #6A7314;
  --onSurfaceContainerVariant: #55574B;
  --primary_darkMode: #A5B339;
  --surfaceContainerLowest_darkMode: #151515;
  --errorContainer: #FFD1D1;
  --surfaceContainer: #F0F0F0;
  --surfaceDim_darkMode: #121212;
  --surface_darkMode: #121212;
  --surfaceContainerHighest_darkMode: #313131;
  --primaryFixed: #A5B339;
  --surface: #FFFFFF;
  --onSurfaceContainer: #272727;
  --surfaceBright_darkMode: #313131;
  --onSecondaryContainer: #272727;
  --tertiary: #464641;
  --onTertiaryContainer: #272727;
  --inversePrimary: #A5B339;
  --secondary: #484D28;
  --onPrimaryFixed_darkMode: #272727;
  --onTertiaryFixed: #272727;
  --inverseSurface: #212121;
  --surfaceContainerLow_darkMode: #1A1A1A;
  --secondaryInput: #E0E6B3;
  --primaryInput: #6A7314;
  --errorContainer_darkMode: #6F3534;
  --onTertiary_darkMode: #272727;
  --secondaryFixed: #E0E6B3;
  --tertiaryFixedDim_darkMode: #D0D1C7;
  --onSecondaryFixed: #272727;
  --onSecondary: #FFFFFF;
  --surfaceContainerHigh: #E6E5E6;
  --onPrimaryFixedVariant_darkMode: #33342B;
  --secondary_darkMode: #E0E6B3;
  --primary: #6A7314;
  --surfaceContainerLowest: #FFFFFF;
  --onPrimary: #FFFFFF;
  --onTertiaryFixed_darkMode: #272727;
  --secondaryFixedDim: #C7CC9F;
  --onTertiary: #FFFFFF;
  --tertiaryFixed: #DBDDD3;
  --onSecondaryFixedVariant_darkMode: #33342B;
  --inverseOnSurface_darkMode: #272727;
  --error: #CB2B29;
  --primaryFixedDim: #98A535;
  --onTertiaryFixedVariant_darkMode: #33342B;
  --outline: #999999;
  --onErrorContainer_darkMode: #FFFFFF;
  --outlineVariant: #C3C3C3;
  --tertiaryFixed_darkMode: #DBDDD3;
  --inverseSurface_darkMode: #F0F0F0;
  --onTertiaryFixedVariant: #33342B;
  --onSecondary_darkMode: #272727;
  --primaryFixedDim_darkMode: #98A535;
  --outlineVariant_darkMode: #4D4D4D;
  --onPrimaryFixed: #272727;
  --onSecondaryFixed_darkMode: #272727;
  --onTertiaryContainer_darkMode: #FFFFFF;
  --onError: #FFFFFF;
  --surfaceContainerLow: #F8F8F8;
  --surfaceContainer_darkMode: #212121;
  --secondaryFixed_darkMode: #E0E6B3;
  --error_darkMode: #FF756F;
  --onPrimaryContainer_darkMode: #FFFFFF;
  --secondaryFixedDim_darkMode: #C7CC9F;
  --onPrimaryFixedVariant: #33342B;
  --surfaceDim: #E7E7E7;
  --primaryFixed_darkMode: #A5B339;
  --tertiary_darkMode: #DBDDD3;
  --onSecondaryContainer_darkMode: #FFFFFF;
}`;
      const styleTag = document.createElement("style");
      styleTag.type = "text/css";
      styleTag.id = styleTagId;
      styleTag.innerHTML = css;
      document.head.appendChild(styleTag);
    },
    addOutdoorActiveTourDataDownloadButton() {
      this.addOutdooractivePdfDialogCSS();
      window.oa.pdfDialog(
        this.outdoorActiveTourId,
        document.getElementById("download_outdoor_active_tour_data_pdf_btn")
      );
    }
  },
  data: () => ({
    readMore: false,
    socialShareDialog: false
  }),
  computed: {
    categoryGroups() {
      return this.$store.state.categoryGroups;
    },
    categoryTypes() {
      return this.$store.state.categoryTypes;
    },
    hideFeatureSummer() {
      return this.settings.apiKey.hideFeatureSummer;
    },
    hideFeatureWinter() {
      return this.settings.apiKey.hideFeatureWinter;
    },
    cOpenPanel: {
      get() {
        return this.openPanel;
      },
      set(value) {
        this.$emit("openPanelChanged", value);
      }
    }
  }
};
